import gatewaysTotalWidgetTemplate from './gatewaysTotalWidget.html';
import './gatewaysTotalWidget.scss';

export default angular
  .module('main.dashboardPanel.gatewaysTotalWidget', [])

  .directive('gatewaysTotalWidget', () => {
    return {
      restrict: 'E',
      template: gatewaysTotalWidgetTemplate,
      scope: {},
      controller: ($scope,
                   utils,
                   $filter,
                   DashboardDataProvider) => {
        const $t = $filter('translate');
        $scope.noData = false;
        init();

        function init() {
          $scope.loading = true;

          DashboardDataProvider.getTotalGatewaysLastWeek()
            .then((reportInfo) => {
              $scope.loading = false;
              if (!reportInfo || !reportInfo.dictionary || reportInfo.dictionary.length <= 0 || !reportInfo.executions || reportInfo.executions.length <= 0) {
                $scope.noData = true;
                return;
              }

              let executions = reportInfo.executions
                .slice()
                .sort((a, b) => a.executionDateMs - b.executionDateMs); // latest last

              let connectedGateways = executions
                .map(execution => ({
                  x: execution.executionDateMs,
                  y: execution.data?.find(d => d.id === 1)?.value || 0
                }));

              let disconnectedGateways = executions
                .map(execution => ({
                  x: execution.executionDateMs,
                  y: execution.data?.find(d => d.id === 2)?.value || 0
                }));

              $scope.series = [
                {
                  data: disconnectedGateways,
                  label: $t('dash.panel.reports.totalGateways.disconnected')
                },
                {
                  data: connectedGateways,
                  label: $t('dash.panel.reports.totalGateways.connected')
                }
                
              ];
            }, (err) => {
              utils.handleApiError(err);
              $scope.loading = false;
            });
        }
      }
    };
  })
  .name;
